import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { ORIGINAL_PRICE, PRICE, PRODUCT_IMAGE, copy, offerIncludes, offerRows } from '../data/noklar';
import { CtaButton } from './CtaButton';
export function Offer() {
  const t = copy.offer;
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-226" data-mp="1mplmk7jpxqnx">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-227" data-mp="1hqs4e1thlbhf">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-228" data-mp="tz3fkvfvj558">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-229" data-mp="p0jvl0kuc3fi">
            {t.titleStart} <em className="text-red-300" data-id="element-230" data-mp="13y2g1qqhjuh5">{t.brand}</em>{t.titleEnd}
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-231" data-mp="yxerrctn5rqm">
            {t.text}
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-232" data-mp="2fb4ykrc5au3y" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-233" data-mp="2actqom5eutod">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-234" data-mp="uisfdix0l0wu">{t.includesLabel}</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-235" data-mp="zioa0rjtnfzq">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-236" data-mp="13ki6soqwbzum">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-237" data-mp="13hnob2rg0p3u">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-238" data-mp="bskivjntl8pm" />
                </span>
                <span data-id="element-239" data-mp="fu5r2rpesyth">
                  <span className="block font-medium leading-snug" data-id="element-240" data-mp="ftm95azreafg">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-241" data-mp="km5x91w2onyi">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-242" data-mp="3oa7k2xbybdl7">
            <div className="sm:pb-2" data-id="element-243" data-mp="vefto3dhg71m">
              <p className="text-sm text-slate-900/60" data-id="element-244" data-mp="vde5cx7gho1y">
                {t.originalLabel} <s data-id="element-245" data-mp="qg4hhlzptkg8">{ORIGINAL_PRICE}</s>
              </p>
              <p className="text-sm font-medium text-slate-900/70" data-id="element-246" data-mp="15621dpqm3nzm">{t.priceLabel}</p>
            </div>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-247" data-mp="105xkvzppet9e">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-248" data-mp="ciz5l5dblrd2">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-249" data-mp="7k4pib6qmgwn" />
            {t.oneTime}
          </p>

          <CtaButton label={t.cta} className="mt-8 w-full" data-id="element-250" data-mp="hfzd7kptj26a" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-251" data-mp="heejfxbbvn9h">
            {offerIncludes.map(item => <li key={item} data-id="element-252" data-mp="1sv4sdo74yt6s">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}